<template>
  <div class="classification" v-if="this.items.length > 1 ">
    <span>Classifications</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.name+' ['+item.id+']'">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventClassification',
  computed: {
    items () {
      const filter = this.$store.getters['Sport/Classification/filtered']
      return this.$store.getters['Sport/Classification/list'].filter(item => filter.indexOf(item.id) > -1)
    }
  }
}
</script>

<style scoped>
  .classification{
    display:flex;
    align-items:center;
    margin-top:10px
  }
  .classification > span{
    font-size:14px
  }
  .classification > select{
    height:18px;
    margin-left:5px
  }
</style>
